import { asStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { Button, Input } from "@fluentui/react-components";
import { AddFilled } from "@fluentui/react-icons";

interface TeamMembersToolbarProps {
  onAddClick: () => void;
  searchInput: string;
  onSearchChange: (value: string) => void;
  isSearchDisabled: boolean;
}

export const TeamMembersToolbar = ({
  onAddClick,
  searchInput,
  onSearchChange,
  isSearchDisabled,
}: TeamMembersToolbarProps) => (
  <div className="flex w-full flex-row justify-between gap-3">
    <Button
      appearance="subtle"
      className="md:self-center"
      icon={<AddFilled />}
      onClick={onAddClick}
      type="button"
    >
      Add member
    </Button>
    <Input
      aria-label="Search members"
      disabled={isSearchDisabled}
      onChange={asStableCallback((_event, data) => {
        onSearchChange(data.value ?? "");
      })}
      placeholder="Search members"
      value={searchInput}
    />
  </div>
);
